import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SectionTitle, Loading, StatusChip, Placeholder } from "@/components/common";
import { GraduationCap, Award, ShieldAlert, BookOpen } from "lucide-react";

export default function Academy() {
  const [modules, setModules] = useState(null);
  const [passport, setPassport] = useState(null);

  useEffect(() => {
    api.get("/academy/modules").then(({ data }) => setModules(data));
    api.get("/academy/passport").then(({ data }) => setPassport(data));
  }, []);

  if (!modules || !passport) return <Loading label="Loading academy" />;

  return (
    <div className="max-w-6xl">
      <SectionTitle sub="Training architecture · certifications · restrictions">FreshSurf Academy</SectionTitle>

      <div className="sg-card p-5 mb-6" style={{ borderColor: "var(--accent)", background: "rgba(255,87,34,0.06)" }} data-testid="academy-rule">
        <div className="font-head font-bold uppercase tracking-widest text-sm mb-1" style={{ color: "var(--accent)" }}>Certification Standard</div>
        <div className="font-head text-lg font-semibold">{passport.rule}</div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <div className="font-head text-xl font-bold mb-3 flex items-center gap-2"><BookOpen size={20} style={{ color: "var(--accent)" }} /> Training Modules</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="academy-modules">
            {modules.map((m) => (
              <div key={m.id} className="sg-card p-4" data-testid={`module-${m.key}`}>
                <div className="font-head font-bold">{m.name}</div>
                <div className="flex flex-wrap gap-2 mt-2">
                  {m.restricted_service && <StatusChip status="warning" label="Restricted Service" />}
                  <Placeholder label={m.sop_status} />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <div className="sg-card p-5" data-testid="passport-certs">
            <div className="font-head text-lg font-bold mb-3 flex items-center gap-2"><Award size={18} style={{ color: "#10B981" }} /> My Certifications</div>
            {passport.certifications.length === 0 && <div className="text-sm" style={{ color: "var(--txt2)" }}>No certifications yet.</div>}
            {passport.certifications.map((c) => (
              <div key={c.id} className="flex items-center justify-between mb-2">
                <span className="text-sm">{c.name}</span><StatusChip status="certified" />
              </div>
            ))}
          </div>
          <div className="sg-card p-5" data-testid="passport-restrictions">
            <div className="font-head text-lg font-bold mb-3 flex items-center gap-2"><ShieldAlert size={18} style={{ color: "var(--warn)" }} /> Restrictions</div>
            {passport.restrictions.length === 0 && <div className="text-sm" style={{ color: "var(--txt2)" }}>No restrictions.</div>}
            {passport.restrictions.map((r) => (
              <div key={r.id} className="text-sm p-2 rounded-lg mb-2" style={{ background: "rgba(245,158,11,0.08)", color: "#F59E0B" }}>
                {r.restriction} <span className="text-xs">· {r.assist_level?.replace(/_/g, " ")}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
